import { NavLink } from 'react-router';
import { cx } from '../../ui/cx';
import s from './SideNav.module.css';

/**
 * One nav destination.
 *
 * The styles live in SideNav.module.css rather than a module of this component's own,
 * because the active marker is one of the five allow-listed seal uses and the allow-list
 * names it by selector: `src/features/shell/SideNav.module.css:.navItem[aria-current="page"]::before`.
 * Moving the rule to another file would fail check-brand.sh, and the fix would be to edit
 * the allow-list — which is a brand decision, not a refactor.
 *
 * NavLink sets aria-current="page" itself when the route matches, so the marker is driven
 * by the same fact a screen reader is told, not by a parallel bit of state.
 */
export function NavItem({
  to,
  label,
  onNavigate,
  end = false,
}: {
  to: string;
  label: string;
  onNavigate?: () => void;
  /** Active on this path alone: `/containers` must not light up on every container's pages. */
  end?: boolean;
}) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) => cx(s.navItem, isActive && s.navItemActive)}
      {...(onNavigate ? { onClick: onNavigate } : {})}
    >
      {label}
    </NavLink>
  );
}

export default NavItem;
